
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Mail, Home } from "lucide-react";
import ContactForm from "@/components/contact/ContactForm";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleHomeClick = () => {
    console.log('Header home click');
    window.location.href = '/';
  };

  return (
    <header className="bg-gray-700 text-white py-4 text-center shadow-md">
      <div className="container mx-auto px-4 relative">
        <div className="text-center">
          <h1 
            className="text-2xl font-bold cursor-pointer hover:text-gray-300 transition-colors"
            onClick={handleHomeClick}
          >
            gerball.co.uk
          </h1>
          <h2 className="text-lg mt-1">Football Data Analysis</h2>
        </div>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button 
              variant="ghost" 
              className="absolute right-4 bottom-0 text-gray-300 hover:text-white hover:bg-gray-600"
            >
              <Mail className="mr-2 h-4 w-4" />
              Contact
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Contact Us</DialogTitle>
            </DialogHeader>
            <ContactForm isOpen={isOpen} setIsOpen={setIsOpen} />
          </DialogContent>
        </Dialog>
        
        <Button 
          variant="ghost" 
          className="absolute left-4 bottom-0 text-gray-300 hover:text-white hover:bg-gray-600"
          onClick={handleHomeClick}
        >
          <Home className="mr-2 h-4 w-4" />
          Home
        </Button>
      </div>
    </header>
  );
};

export default Header;
